function initPriceUpdater() {
  document.querySelectorAll('.product-info__block-list').forEach(function(block) {
    const qtyInput = block.querySelector('.quantity-selector__input');
    const salePrice = block.querySelector('sale-price');
    if (!qtyInput || !salePrice || qtyInput.dataset.priceInit) return;

    const unitPrice = parseFloat(
      salePrice.textContent.trim().replace(/[^\d,]/g, '').replace(',', '.')
    );
    if (isNaN(unitPrice)) return;

    qtyInput.dataset.priceInit = 'true';

    const totalEl = document.createElement('span');
    totalEl.className = 'lovher-price-total h4 text-on-sale';
    totalEl.style.cssText = 'display:none;color:#fd2d94;font-weight:700;margin-left:4px;';
    salePrice.parentNode.insertBefore(totalEl, salePrice.nextSibling);

    function updateTotal() {
      const qty = parseInt(qtyInput.value) || 1;
      if (qty > 1) {
        const total = (unitPrice * qty).toFixed(2).replace('.', ',');
        totalEl.textContent = total + '\u20ac';
        totalEl.style.display = 'inline';
        salePrice.style.display = 'none';
      } else {
        totalEl.style.display = 'none';
        salePrice.style.display = '';
      }
    }

    const buttons = block.querySelectorAll('.quantity-selector__button');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setTimeout(updateTotal, 50);
      });
    });

    qtyInput.addEventListener('input', updateTotal);
    qtyInput.addEventListener('change', updateTotal);

    const observer = new MutationObserver(updateTotal);
    observer.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });
  });
}

document.addEventListener('DOMContentLoaded', initPriceUpdater);
setTimeout(initPriceUpdater, 800);

function lovherPatchBundle() {

  // 1. Bouton
  const btn = document.querySelector('.pmpr_bundle__add_to_cart');
  if (btn && !btn.dataset.patched) {
    btn.textContent = "J'adopte le Duo →";
    btn.dataset.patched = 'true';
  }

  // 2. Footer
  const buyAll = document.querySelector('.pmpr_bundle__buy_all');
  if (buyAll && !buyAll.dataset.patched) {
    const discountText = buyAll.querySelector('.pmpr_bundle__footer_text')?.textContent?.trim() || '';
    const comparePrice = buyAll.querySelector('.pmpr_bundle__compare_price_text')?.textContent?.trim() || '';
    const totalPrice   = buyAll.querySelector('.pmpr_bundle__total_price_text')?.textContent?.trim() || '';

    buyAll.innerHTML = `
      <div style="display:flex;flex-direction:column;align-items:center;text-align:center;gap:6px;width:100%;padding:12px 0;">
        <div style="background:#FD2D94;color:#fff;font-size:11px;font-weight:700;border-radius:20px;padding:3px 12px;letter-spacing:0.04em;">DUO</div>
        <div style="color:#1A1A1A;font-size:13px;font-weight:700;">${discountText}</div>
        <div style="display:flex;align-items:center;gap:8px;">
          <span style="color:#AAAAAA;font-size:13px;text-decoration:line-through;">${comparePrice}</span>
          <span style="color:#FD2D94;font-size:22px;font-weight:700;">${totalPrice}</span>
        </div>
        <div style="color:#2D9B5A;font-size:12px;font-weight:600;">✓ Vous économisez 5€ sur ce duo</div>
      </div>
    `;
    buyAll.style.cssText = 'background:#FFF0F5;border-top:1px solid #FFD6E8;padding:0 16px;';
    buyAll.dataset.patched = 'true';
  }

  // 3. Fix coupure titres
  document.querySelectorAll('.pmpr_bundle__product_name_text').forEach(el => {
    el.style.cssText += 'font-size:12px;line-height:1.4;word-break:normal;hyphens:none;';
  });
}
// 4. Gras sur le nom produit uniquement (avant le "—")
document.querySelectorAll('.pmpr_bundle__product_name_text').forEach(el => {
  const text = el.textContent.trim();
  const parts = text.split('—');
  if (parts.length >= 2) {
    el.innerHTML = `<strong>${parts[0].trim()}</strong> — ${parts.slice(1).join('—').trim()}`;
  } else {
    el.style.fontWeight = '700'; // fallback si pas de "—"
  }
});
// 5. Séparateur visuel avant le bloc bundle
const pumper = document.querySelector('.pmpr_bundle__root');
if (pumper && !document.querySelector('.lovher-bundle-separator')) {
  const separator = document.createElement('div');
  separator.className = 'lovher-bundle-separator';
  separator.style.cssText = 'display:flex;align-items:center;gap:12px;margin:16px 0 8px;';
  separator.innerHTML = `
    <div style="flex:1;height:1px;background:#FFD6E8;"></div>
    <div style="color:#FD2D94;font-size:11px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;white-space:nowrap;">✨ Profitez du Duo</div>
    <div style="flex:1;height:1px;background:#FFD6E8;"></div>
  `;
  pumper.parentElement.insertBefore(separator, pumper);
}
// 6. Bouton d'achat unitaire
const btnNatif = document.querySelector('#product-form-8750750204250-template--28195730850138__main .button');
if (btnNatif && !btnNatif.dataset.patched) {
  btnNatif.textContent = "J'adopte la LOV.Cup →";
  btnNatif.dataset.patched = 'true';
}
// 7. Texte accordéons en 14px
document.querySelectorAll('.accordion-group li, .accordion-group p').forEach(el => {
  el.style.fontSize = '14px';
  el.style.lineHeight = '1.5';
});
// 8. Déplacer les accordéons sous le bloc product entier
const accordion = document.querySelector('.accordion-group');
const product = document.querySelector('.product');
if (accordion && product && !accordion.dataset.moved) {
  product.parentElement.insertBefore(accordion, product.nextSibling);
  accordion.style.cssText = 'max-width:1200px; margin:0 auto; padding:0 20px;';
  accordion.dataset.moved = 'true';
}
// Observer body directement
const observer = new MutationObserver(() => {
  if (document.querySelector('.pmpr_bundle__add_to_cart')) {
    observer.disconnect();
    setTimeout(lovherPatchBundle, 150);
  }
});
observer.observe(document.body, { childList: true, subtree: true });

// Sous-titre rose — toutes les fiches produit
const subtitle = document.querySelector('.product-page-subtitle');
if (subtitle) {
  subtitle.style.setProperty('color', '#FD2D94', 'important');
}

// Taille de texte globale — toutes les fiches produit
function lovherFixTextSize() {
  document.querySelectorAll(
    '.product-info .prose p, .product-info .prose li, .accordion-group p, .accordion-group li'
  ).forEach(el => {
    el.style.setProperty('font-size', '15px', 'important');
    el.style.setProperty('line-height', '1.5', 'important');
  });
}

// Exécuter au chargement + après le rendu des blocs dynamiques
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(lovherFixTextSize, 300));
} else {
  setTimeout(lovherFixTextSize, 300);
}
// CTA Stérilisateur
function lovherPatchSterilisateur() {
  if (!window.location.pathname.includes('sterilisateur')) return;
  const btn = document.querySelector('.shopify-product-form .button');
  if (btn && !btn.dataset.patched) {
    btn.textContent = "J'adopte le Stérilisateur →";
    btn.dataset.patched = 'true';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(lovherPatchSterilisateur, 300));
} else {
  setTimeout(lovherPatchSterilisateur, 300);
}
function applyFaqTextSize() {
  document.querySelectorAll('.accordion__content .prose p, .accordion__content .prose li').forEach(el => {
    el.style.setProperty('font-size', '13px', 'important');
    el.style.setProperty('line-height', '1.6', 'important');
    el.style.setProperty('color', '#555', 'important');
  });
}

// Au chargement
applyFaqTextSize();

// Au clic sur un accordéon (pour les éléments ouverts dynamiquement)
document.querySelectorAll('.accordion summary').forEach(summary => {
  summary.addEventListener('click', () => {
    setTimeout(applyFaqTextSize, 50);
  });
});